<template>
  <div class="modal-content">
    <div class="form-in-scroll other-lots-layout">
      <div class="other-lots-header">
        <div class="other-lots_checkbox" @click="toggleSelectAll">
          <div
            class="checkbox-ui"
            :class="{
              checked: allChecked,
              indeterminate: !allChecked && isIndeterminate,
            }"
          >
            <span class="checkmark"></span>
          </div>
        </div>
        <TagLotsButton
          :dropdownRight="true"
          :disabled="disableMarkButton"
          @toggle-tag="handleToggleTagSelected"
        />
      </div>
      <ul class="other-lots-list">
        <li class="other-lots-lot" v-for="lot in lots" :key="lot.id">
          <div class="other-lots_checkbox" @click="toggleLot(lot.id)">
            <div
              class="checkbox-ui"
              :class="{
                checked: isChecked(lot.id),
              }"
            >
              <span class="checkmark"></span>
            </div>
          </div>
          <div class="other-lots-lot_mark">
            <div class="marker-favorites">
              <div
                class="marker-part"
                :style="{ backgroundColor: lot.marks?.color }"
              />
            </div>
          </div>
          <div class="other-lots-lot_name">
            <span v-html="highlight(lot.name)" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import api from "@/application";
import { mapActions, mapGetters } from "vuex";
import TagLotsButton from "../tags/TagLotsButton.vue";
import { mapColumnsFilters } from "@/utils/mapper";
import { getPurchasesUrl } from "@/utils/purchasesURL";
import { highlightSubstring } from "@/utils/highlightSubstring";

export default {
  name: "OtherLotsModal",
  props: ["componentProps"],
  components: { TagLotsButton },
  data() {
    return {
      lots: [],
      selectedLots: {},
    };
  },
  methods: {
    ...mapActions("tags", ["tagLots", "untagLots"]),
    ...mapActions("purchases", ["getPurchases"]),

    highlight(name) {
      return highlightSubstring(name, this.currentTab.searchCriteria.keyWords);
    },

    isChecked(id) {
      return !!this.selectedLots[id];
    },
    toggleLot(id) {
      if (this.selectedLots[id]) {
        this.$delete(this.selectedLots, id);
      } else {
        this.$set(this.selectedLots, id, true);
      }
    },
    toggleSelectAll() {
      if (this.allChecked) {
        this.selectedLots = {};
      } else {
        this.selectedLots = Object.fromEntries(
          this.lots.map((lot) => [lot.id, true]),
        );
      }
    },
    async getNewPurchases() {
      await this.getPurchases({
        url: getPurchasesUrl(this.currentTab.filterType),
        profileId: this.profileId,
        customFilters: mapColumnsFilters(this.columnsFilters),
        currentTab: this.currentTab,
        isActiveSearch: this.isActiveSearch,
        size: this.pagination.value,
        sort: this.columnSort,
        filterId: this.currentTab.id,
        page: this.page.number,
      });
    },
    async handleToggleTagSelected(action, tagId) {
      const selectedLots = Object.keys(this.selectedLots).map(Number);

      if (!selectedLots.length) return;

      try {
        if (action === "tag") {
          await this.tagLots({
            markId: tagId,
            lotIds: selectedLots,
          });
        } else if (action === "untag") {
          const markedLotsMap = new Map();

          selectedLots.forEach((id) => {
            const lot = this.lots.find((lot) => lot.id === id);

            if (!lot || !lot.marks?.markId) return;

            const { markId, lotId } = lot.marks;

            if (!markedLotsMap.has(markId)) {
              markedLotsMap.set(markId, []);
            }

            markedLotsMap.get(markId).push(lotId);
          });

          const markedLotsArray = Array.from(
            markedLotsMap,
            ([markId, lotIds]) => ({
              markId,
              lotIds,
            }),
          );

          await this.untagLots(markedLotsArray);
        }

        this.selectedLots = {};
        await this.getLots();
        await this.getNewPurchases();
      } catch (e) {
        throw new Error(e);
      }
    },

    async getLots() {
      try {
        const { data } = await api.purchases.getAllLots(
          this.componentProps.row.id,
          this.profileId,
        );
        this.lots = data;
      } catch (e) {
        this.$toast.error(e.response.data.errorMessage);
      }
    },
  },
  computed: {
    ...mapGetters("profile", ["profileId"]),
    ...mapGetters("filterTabs", ["currentTab"]),
    ...mapGetters("profile", ["profileId"]),
    ...mapGetters("columnsFilters", ["columnsFilters"]),
    ...mapGetters("purchasesTableSettings", ["isActiveSearch"]),
    ...mapGetters("purchasesTableSettings", ["pagination"]),
    ...mapGetters("columnsSort", ["columnSort"]),
    ...mapGetters("purchases", ["page"]),
    ...mapGetters("filterTabs", ["currentTab"]),

    selectedCount() {
      return Object.keys(this.selectedLots).length;
    },

    allChecked() {
      return this.lots.length > 0 && this.selectedCount === this.lots.length;
    },

    isIndeterminate() {
      return this.selectedCount > 0 && this.selectedCount < this.lots.length;
    },

    disableMarkButton() {
      return this.selectedCount === 0;
    },
  },
  async created() {
    this.getLots();
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/less/variables.less";

.other-lots_checkbox {
  width: 24px;
  height: 24px;
  min-width: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .checkbox-ui {
    width: 17px;
    height: 17px;
    border: 2px solid #cfd8dd;
    border-radius: 2px;
    position: relative;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    .checkmark {
      opacity: 0;
    }

    &.checked {
      background-color: #37474f;
      border-color: #37474f;

      .checkmark {
        position: absolute;
        width: 12px;
        height: 7px;
        border-left: 2px solid white;
        border-bottom: 2px solid white;
        transform: rotate(-45deg);
        bottom: 5px;
        opacity: 1;
        transition: opacity 0.2s ease;
      }
    }
    &.indeterminate {
      background-color: #37474f;
      border-color: #37474f;
      .checkmark {
        position: absolute;
        width: 10px;
        bottom: 5.5px;
        border-bottom: 2px solid white;
        opacity: 1;
      }
    }
  }
}

.other-lots-layout {
  display: flex;
  flex-direction: column;
  height: 450px;
  min-height: 450px;
  gap: 16px;
  padding-top: 0;
  overflow: hidden;
  .other-lots-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
    .select-all-lots {
      font-family: Roboto;
      font-weight: 400;
      font-size: 14px;
      color: #7d919b;
      height: 48px;
      display: flex;
      align-items: center;
      gap: 12px;

      &:hover {
        background-color: fade(@bg-color-light, 50%);
      }
    }
  }

  .other-lots-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    overflow-y: auto;
    padding-right: 8px;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: #f7f7f7;
      border-radius: 999px;
    }
    &::-webkit-scrollbar-thumb {
      background: #d3d3d3;
      border-radius: 999px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #d3d3d3;
    }

    .other-lots-lot {
      display: flex;
      align-items: stretch;
      &_mark {
        width: 24px;
        min-width: 24px;
        display: flex;
        justify-content: center;
        .marker-favorites {
          width: 8px;
          max-width: 8px;
          border-radius: 1px;
          overflow: hidden;
          display: flex;
          flex: 1;
          flex-direction: column;
          margin: 4px 0;
          .marker-part {
            flex: 1;
          }
        }
      }
      &_name {
        font-family: Roboto;
        font-weight: 400;
        font-size: 13px;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
